import useSWR, { ConfigInterface, keyInterface, responseInterface } from 'swr';
import { fetcher } from '../../../lib/api/fetcher';
//eslint-disable-next-line @typescript-eslint/no-explicit-any
type Data = any; type Error = any;

type Fn<T> = (...args: T[]) => T | Promise<T>;

export const _defaults = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
};


const isInactiveKey = (key: keyInterface): boolean => {
  let resolved: unknown = key;
  if (typeof key === 'function') {
    try {
      resolved = key();
    } catch {
      return true;
    }
  }
  if (Array.isArray(resolved)) return resolved.length === 0;
  return resolved === null || resolved === '';
};

export const useSWRWithDefaults = (
  key: keyInterface,
  fn: Fn<Data> = fetcher,
  config: ConfigInterface = {}
): responseInterface<Data, Error> => {
  const result = useSWR(key, fn, { ..._defaults, ...config });
  if (!isInactiveKey(key)) return result;

  return {
    data: result.data,
    error: result.error,
    revalidate: result.revalidate,
    mutate: result.mutate,
    isValidating: false
  };
};
